import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';

import { useSupporterVoicesFeed } from './useSupporterVoicesFeed';

/**
 * Single source of truth for whether the mixed supporter voices feed should replace the
 * legacy comments/videos sections: the FCM must be set AND there must be enough items to
 * fill the feed. Both the page layout wrapper (Main.tsx) and the section content
 * (SupporterVoices) read this so their decisions can't diverge.
 */
export function useShowSupporterVoicesFeed(): boolean {
	const {
		data: {
			featureConfigs: { supporterVoicesMix },
		},
	} = usePetitionDetailsPageData();

	const {
		data: { showFeed },
	} = useSupporterVoicesFeed();

	return Boolean(supporterVoicesMix) && showFeed;
}
